module.exports = __webpack_public_path__ + "static/media/hmedium@2x.41125815.png";